import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import { motion } from 'framer-motion'; 
import Blog1 from '../Components/img/Blog1.jpg';  
import Blog2 from '../Components/img/Blog2.jpeg';  
import Blog3 from '../Components/img/Blog8.jpeg';  
import Blog4 from '../Components/img/Blog6.webp'; 
import Blog5 from '../Components/img/Blog5.jpeg';  
import Blog6 from '../Components/img/Blog.webp';  
import { Helmet } from 'react-helmet';
const Blog = () => {
  const cards = [
    {
      title: "The Importance of Mental Health",
      text: "Understanding the significance of mental health and how it affects our daily lives. Learn why mental wellness is essential for overall health.",
      imgSrc: Blog1,
      link: "/MentalHealth",
    },
    {
      title: "Managing Stress",
      text: "Learn effective ways to manage stress through breathing exercises, mindfulness, and other techniques that promote mental clarity and emotional well-being.",
      imgSrc: Blog2,
      link: "/ManagingStress",
    },
    {
      title: "Dealing with Anxiety: A Guide",
      text: "Anxiety is common but can be overwhelming. Explore strategies for dealing with anxiety and understanding its triggers to lead a calmer, more balanced life.",
      imgSrc: Blog3,
      link: "/DealingWithAnxiety",
    },
    {
      title: "Mindfulness and Mental Clarity",
      text: "Discover the practice of mindfulness and how it can help you achieve mental clarity, reduce stress, and improve overall emotional resilience.",
      imgSrc: Blog4,
      link: "/Mindfulness",
    },
    {
      title: "Building Healthy Relationships ",
      text: "Relationships have a significant impact on our mental health. Learn how to foster healthy relationships that contribute positively to your emotional well-being.",
      imgSrc: Blog5,
      link: "/BuildingHealthyRelationships",
    },
    {
      title: "Self-Care Tips for Mental Health",
      text: "Self-care is a vital aspect of maintaining good mental health. Explore practical tips and self-care strategies to prioritize your well-being.",
      imgSrc: Blog6,
      link: "/SelfCareMentalHealth",
    },
  ];

  return (
<>
<Helmet>
        <title>Mental Health Blog - Expert Advice & Tips</title>
        <meta name="google-site-verification" content="hDy2TyO5-XOsY-kqHa_AsfhwAKrzVrvGjXLKbQkdVlw" />
        <meta
          name="description"
          content="Explore expert blog posts on mental health, stress management, mindfulness, and self-care. Learn tips for leading a healthier, balanced life."
        />
        <meta
          name="keywords"
          content="mental health, stress management, mindfulness, anxiety, self-care, healthy relationships"
        />
        <meta name="author" content="Swati Chavhan -Psychiatric"/>
        <meta property="og:title" content="Mental Health Blog - Expert Advice & Tips" />
        <meta
          property="og:description"
          content="Explore expert blog posts on mental health, stress management, mindfulness, and self-care. Learn tips for leading a healthier, balanced life."
        />
        
        <meta property="og:image" content="path/to/your/image.jpg" />
        <meta property="og:url" content="https://drswatichavhanpsychiatrist.com//blog" />
        <meta name="twitter:title" content="Mental Health Blog - Expert Advice & Tips" />
        <meta name="twitter:description" content="Explore expert blog posts on mental health, stress management, mindfulness, and self-care." />
        <meta name="twitter:image" content="path/to/your/image.jpg" />
      </Helmet>
      <Container className="d-flex flex-wrap justify-content-between mt-5">
  <Row>
    {cards.map((card, index) => (
      <Col xs={12} sm={6} md={4} lg={4} key={index} className="mb-4">
        <motion.div
          initial={{ opacity: 0, x: -100 }} 
          animate={{ opacity: 1, x: 0 }} 
          transition={{ delay: 0.2 * index, type: 'spring', stiffness: 100 }} 
        >
          <Link to={card.link} style={{ textDecoration: 'none' }}>
            <Card className="shadow-sm border-0 rounded">
              <Card.Img
                variant="top"
                src={card.imgSrc}
                style={{ height: '200px', objectFit: 'cover' }}
              />
              <Card.Body style={{ padding: '1.25rem' }}>
                <Card.Title className="" style={{ color: '#093c60' }}>{card.title}</Card.Title>
                <Card.Text>{card.text}</Card.Text>
              </Card.Body>
            </Card>
          </Link>
        </motion.div>
      </Col>
    ))}
  </Row>
</Container>

</>
  );
};

export default Blog;
